import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MyStorageService} from './services/common/my-storage.service';
import {Constants} from './utils/constants';
import {CoreDataService} from "./services/wrapper/core-data.service";
import {NotificationData} from "./services/common/websocket-notification.service";
import {Utilities} from "./utils/utilities";
import {RestaurantService} from "./services/restaurant.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(public translate: TranslateService, private myStorage: MyStorageService, private coreDataService: CoreDataService, private restaurantService: RestaurantService) {
        translate.addLangs(Constants.SYSTEM_LANGUAGES);
        translate.setDefaultLang(Constants.DEFAULT_LANGUAGE);

    }

    ngOnInit(): void {
        const lang = this.myStorage.getFromCookies(Constants.STORAGE_KEYS.LANGUAGE, Constants.DEFAULT_LANGUAGE);
        this.translate.use(lang);
        this.storeCoreData();
        this.removeNotification();
    }

    storeCoreData() {
        this.restaurantService.storeUsersRestaurants();
        this.coreDataService.storeLanguage();
        this.coreDataService.storeCurrencies();
        this.coreDataService.storeLocalization();

    }

    private removeNotification() {
        const notificationElements = new Map();
        const notifications = Utilities.objectToMap<NotificationData>(this.myStorage.getFromStore(Constants.NOTIFICATION_KEY, {}));

        let date = new Date();
        date.setDate(date.getDate() - 1);

        notifications.forEach(notification => {
            if (notification.createdAt > date.getTime()) {
                notificationElements.set(notification.key, notification);
            }
        });
        this.myStorage.saveToStore(Constants.NOTIFICATION_KEY, Utilities.mapToObject(notificationElements));
    }

}
